import React from 'react';
import { Link, useLocation } from 'wouter';
import { Home, Sparkles, ShoppingBag, ClipboardList, User, Heart } from 'lucide-react';
import { useCart } from '../context/CartContext';
import { useAuth } from '../context/AuthContext';

export default function MobileBottomNav() {
  const [location] = useLocation();
  const { totalItems } = useCart();
  const { user } = useAuth();

  // Hide on admin, facility, or product detail pages (which have dedicated Add to Cart bar)
  if (location.startsWith('/admin') || location === '/facility-login' || location === '/unit-dashboard' || location.startsWith('/product/')) {
    return null;
  }

  const navItems = [
    {
      label: 'Home',
      path: '/',
      icon: Home,
      isActive: location === '/'
    },
    {
      label: 'Spices',
      path: '/products',
      icon: Sparkles,
      isActive: location === '/products' || location.startsWith('/product/')
    },
    {
      label: 'Bag',
      path: '/cart',
      icon: ShoppingBag,
      isActive: location === '/cart',
      badge: totalItems > 0 ? totalItems : undefined
    },
    {
      label: 'Orders',
      path: '/orders',
      icon: ClipboardList,
      isActive: location === '/orders'
    },
    {
      label: user ? 'Account' : 'Profile',
      path: '/account',
      icon: User,
      isActive: location === '/account' || location === '/login' || location === '/wishlist'
    }
  ];

  return (
    <nav 
      aria-label="Mobile Navigation"
      className="fixed bottom-0 left-0 right-0 z-40 lg:hidden bg-[#FAF5EB]/95 backdrop-blur-xl border-t border-[rgba(27,18,12,0.12)] shadow-[0_-4px_20px_rgba(27,18,12,0.06)] pb-[env(safe-area-inset-bottom,0px)]"
    >
      <div className="grid grid-cols-5 items-center h-16 max-w-md mx-auto px-1">
        {navItems.map((item) => {
          const Icon = item.icon;
          const active = item.isActive;
          
          return (
            <Link
              key={item.path}
              href={item.path}
              className={`flex flex-col items-center justify-center min-h-[48px] py-1 px-1 transition-all active:scale-90 group relative ${
                active 
                  ? 'text-[#D97736] font-extrabold' 
                  : 'text-[#63574E] hover:text-[#1B120C]'
              }`}
            >
              <div className="relative">
                <Icon 
                  className={`w-5 h-5 transition-transform duration-200 ${
                    active ? 'scale-110 text-[#D97736] stroke-[2.4]' : 'stroke-[1.8]'
                  }`} 
                />
                {item.badge !== undefined && (
                  <span className="absolute -top-1.5 -right-2.5 bg-[#D97736] text-white text-[9px] font-black min-w-[18px] h-[18px] px-1 rounded-full flex items-center justify-center ring-2 ring-[#FAF5EB] shadow-sm animate-in zoom-in-50">
                    {item.badge}
                  </span>
                )}
              </div>
              <span className={`text-[10px] tracking-tight mt-1 transition-colors ${
                active ? 'text-[#D97736] font-black' : 'font-medium'
              }`}>
                {item.label}
              </span>
              {active && (
                <span className="absolute bottom-1 w-1 h-1 bg-[#D97736] rounded-full" />
              )}
            </Link>
          );
        })}
      </div>
    </nav>
  );
}
